<nb-icon [pack]="'fas'" [icon]="icon()!"></nb-icon>
